import { Breakpoint, ThemeColor } from '@/enums'
import {
  ifNotProps,
  themeBreakpointDown,
  themeColor,
  themeTransition,
  toThemePixels,
} from '@/utils'
import styled, { css } from 'styled-components'
import { ifProp, switchProp } from 'styled-tools'
import { OptionNodeProps } from './OptionNode'

export const Container = styled.div``

const gridStyles = css`
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 10px));
  ${themeBreakpointDown(Breakpoint.sm)} {
    grid-template-columns: repeat(1, 1fr);
  }
`

const verticalStyles = css`
  width: 100%;
  display: flex;
  flex-direction: column;
`

interface CardSelectContainerProps {
  alignment: 'vertical' | 'grid'
}

export const CardSelectContainer = styled.div<CardSelectContainerProps>`
  gap: ${toThemePixels(5)};
  ${switchProp('alignment', {
    vertical: verticalStyles,
    grid: gridStyles,
  })}
`

export const StyledOption = styled.div<OptionNodeProps>`
  position: relative;
  width: ${ifProp('alignment', {
    vertical: '100%',
  })};
  border-radius: ${toThemePixels(3)};
  cursor: pointer;
  border: 1px solid
    ${ifProp(
      'selected',
      themeColor(ThemeColor.success2),
      ifProp(
        'error',
        themeColor(ThemeColor.danger2),
        themeColor(ThemeColor.b30),
      ),
    )};
  display: flex;
  justify-content: ${ifProp('centered', 'center', 'space-between')};
  align-items: baseline;
  padding: ${toThemePixels(4)};
  transition: ${themeTransition('background-color')};
  background-color: ${ifProp(
    'selected',
    themeColor(ThemeColor.success4),
    ifProp('error', themeColor(ThemeColor.danger4)),
  )};
  color: ${ifProp(
    'selected',
    themeColor(ThemeColor.b100),
    themeColor(ThemeColor.b50),
  )};

  &:hover {
    ${ifNotProps(
      ['selected', 'disabled'],
      css`
        border-color: ${themeColor(ThemeColor.success2)};
        background-color: ${themeColor(ThemeColor.success4)};
      `,
    )}
  }
`
